import React from 'react';
import { Card, Text, Image, Group, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface SelectionCardProps {
  value: string;
  label: string;
  description: string;
  image: string;
  onSelect: (value: string) => void;
  isSelected: boolean;
}

const SelectionCard: React.FC<SelectionCardProps> = ({
  value,
  label,
  description,
  image,
  onSelect,
  isSelected,
}) => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery('(max-width: 767px)');

  return (
    <Card
      shadow="sm"
      padding={isMobile ? 'xs' : 'sm'}
      radius="md"
      withBorder
      style={{
        cursor: 'pointer',
        border: isSelected ? `2px solid ${theme.colors.blue[6]}` : 'none',
        transition: 'all 0.2s ease',
      }}
      onClick={() => onSelect(value)}
    >
      <Card.Section>
        <Image
          src={image}
          height={160}
          alt={label}
          style={{
            borderTopLeftRadius: theme.radius.md,
            borderTopRightRadius: theme.radius.md,
          }}
        />
      </Card.Section>

      <Group justify="space-between" mt="md" mb="xs">
        <Text fw={500}>{label}</Text>
      </Group>

      <Text size="sm" c="dimmed">
        {description}
      </Text>
    </Card>
  );
};

export default SelectionCard;
